/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Other_FlexInputs */

const en_salary_negotiate_other_flex = /** @type {(inputs: Salary_Negotiate_Other_FlexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flexible hours`)
};

const de_salary_negotiate_other_flex = /** @type {(inputs: Salary_Negotiate_Other_FlexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flexible Arbeitszeiten`)
};

const fr_salary_negotiate_other_flex = /** @type {(inputs: Salary_Negotiate_Other_FlexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horaires flexibles`)
};

const es_salary_negotiate_other_flex = /** @type {(inputs: Salary_Negotiate_Other_FlexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horario flexible`)
};

const it_salary_negotiate_other_flex = /** @type {(inputs: Salary_Negotiate_Other_FlexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orari flessibili`)
};

const nl_salary_negotiate_other_flex = /** @type {(inputs: Salary_Negotiate_Other_FlexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flexibele werktijden`)
};

const pl_salary_negotiate_other_flex = /** @type {(inputs: Salary_Negotiate_Other_FlexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elastyczne godziny pracy`)
};

const fi_salary_negotiate_other_flex = /** @type {(inputs: Salary_Negotiate_Other_FlexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joustavat työajat`)
};

const da_salary_negotiate_other_flex = /** @type {(inputs: Salary_Negotiate_Other_FlexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fleksible timer`)
};

const sv_salary_negotiate_other_flex = /** @type {(inputs: Salary_Negotiate_Other_FlexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flexibla arbetstider`)
};

/**
* | output |
* | --- |
* | "Flexible hours" |
*
* @param {Salary_Negotiate_Other_FlexInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_other_flex = /** @type {((inputs?: Salary_Negotiate_Other_FlexInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Other_FlexInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_other_flex(inputs)
	if (locale === "fr") return fr_salary_negotiate_other_flex(inputs)
	if (locale === "es") return es_salary_negotiate_other_flex(inputs)
	if (locale === "it") return it_salary_negotiate_other_flex(inputs)
	if (locale === "nl") return nl_salary_negotiate_other_flex(inputs)
	if (locale === "pl") return pl_salary_negotiate_other_flex(inputs)
	if (locale === "fi") return fi_salary_negotiate_other_flex(inputs)
	if (locale === "da") return da_salary_negotiate_other_flex(inputs)
	if (locale === "sv") return sv_salary_negotiate_other_flex(inputs)
	return en_salary_negotiate_other_flex(inputs)
});